import React, { useEffect, useState } from 'react';
import {
  ActividadesGrupos,
  ListadoEmpresas,
  ListadoGrupos,
  ExcepcionFCT,
  Resumen,
  TipoMatricula,
  PagoMatricula,
} from './components';
import { Descuento } from './components/Descuento';
import { Instancia } from './helpers/axios';
import logger from '../../services/logger/logger';

const NuevaMatricula = ({ variant, deployment, mode = 'matricula' }) => {
  // Preparamos variables necesarias
  const [pageCont, setPageCont] = useState(1);
  const [empresaId, setEmpresaId] = useState('CEDESCA');
  const [id, setId] = useState('');
  const [nombreGrupo, setNombreGrupo] = useState('');
  const [tipoCurso] = useState('');
  const [nombreTipoCurso] = useState('');
  const [modulos, setModulos] = useState([]);
  const [codigoGrupo, setCodigoGrupo] = useState('');
  const [isFirstPeriod, setIsFirstPeriod] = useState(false);
  const [isPresencial, setIsPresencial] = useState(false);
  const [isSede, setIsSede] = useState(false);
  const [idDelegacion, setIdDelegacion] = useState({
    idCedesca: -2,
    idCntec: -2,
  });
  const [idDelegacionStudent, setIdDelegacionStudent] = useState({
    bd: '',
    idCentro: -2,
  });
  const [userSession, setUserSession] = useState();
  const [studentStorage, setStudentStorage] = useState({
    id: 0,
    nombre: 'Sin',
    apellidos: 'Datos',
    empresaId: 'CEDESCA',
  });
  const [excepcion, setExcepcion] = useState('');
  const [sumatorio, setSumatorio] = useState(0);
  const [sumatorio2, setSumatorio2] = useState(0);
  const [sumatorioSuelto, setSumatorioSuelto] = useState(0);
  const [sumatorioSuelto2, setSumatorioSuelto2] = useState(0);
  const [precioFinal, setPrecioFinal] = useState(0);
  const [precioCompleto, setPrecioCompleto] = useState(0);
  const [actividades, setActividades] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [descuento, setDescuento] = useState({
    descuento: '0',
    tipo: '',
    id: 0,
  });

  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentType, setPaymentType] = useState(mode === 'presupuesto' ? [] : '');
  const [cuotaDates, setCuotaDates] = useState({});
  const [usesD2L, setUsesD2L] = useState(true); // Flag para determinar si usar D2L o Moodle

  // Efecto que obtiene los datos iniciales
  useEffect(() => {
    // Obtenemos los datos del Storage
    const userSessionString = localStorage.getItem('user');
    const studentStorageString = localStorage.getItem('student');

    // Si existen datos, los seteamos
    if (userSessionString !== null) {
      setUserSession(JSON.parse(userSessionString));
    }
    if (studentStorageString !== null) {
      setStudentStorage(JSON.parse(studentStorageString));
    }
  }, []);

  // Efecto
  useEffect(() => {
    if (variant === 'portal') {
      setPageCont(2);
    }
  }, []);

  // Efecto para obtener el ID de delegación
  useEffect(() => {
    getIdDelegacion();
    getIdDelegacionStudent();
    getIsFirstPeriod();
    getLmsActivo();
  }, [userSession]);

  // Función para obtener el ID de delegación
  const getIdDelegacion = async () => {
    const instance = Instancia(deployment);
    if (userSession) {
      // Declaramos instancia de axios

      const idDel = await instance.get(`getOrgUnit?userEmail=${userSession.profileObj.email}`);

      // Guardamos el resultado
      setIdDelegacion({
        idCedesca: idDel.data.data.idCedesca,
        idCntec: idDel.data.data.idCntec,
      });
    }
  };

  const getIdDelegacionStudent = async () => {
    const instance = Instancia(deployment);
    if (userSession) {
      try {
        const idDel = await instance.get(
          `obtenerCentroAlumno?userEmail=${userSession.profileObj.email}&ccodcli=${studentStorage.id}&headquarter=${empresaId}${mode === 'presupuesto' ? '&isLead=true' : ''}`,
        );

        setIdDelegacionStudent({
          bd: empresaId,
          idCentro: idDel.data?.[0]?.idcentro ?? -2,
        });
      } catch (error) {
        setIdDelegacionStudent({ bd: empresaId, idCentro: -2 });
      }
    }
  };

  const getIsFirstPeriod = async () => {
    if (!userSession?.profileObj?.email) return;

    const instance = Instancia(deployment);

    // Peticiones a la API
    try {
      // Petición para obtener el precio del curso
      const periodoApi = await instance.get(
        `cargarFuncionalidades?headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}`,
      );
      const period = periodoApi.data;

      // Verificar si fechaInicio y fechaFin existen en el segundo objeto (suponiendo que es period[1])
      if (period[1]?.fechaInicio && period[1]?.fechaFin) {
        // Convertimos fechaInicio y fechaFin a objetos Date
        const fechaInicio = new Date(period[1].fechaInicio);
        const fechaFin = new Date(period[1].fechaFin);
        const fechaActual = new Date();

        // Comprobamos si la fecha actual está dentro del rango
        if (fechaActual >= fechaInicio && fechaActual <= fechaFin) {
          setIsFirstPeriod(true); // La fecha actual está dentro del rango
        } else {
          setIsFirstPeriod(false); // La fecha actual está fuera del rango
        }
      }
      // La detección del LMS ahora se hace en getLmsActivo()
    } catch (error) {
      // Si se produce un error, lo registramos sin recargar para evitar loop infinito
      logger.error('Error en cargarFuncionalidades:', error);
      sessionStorage.setItem('apiError', error);
    }
  };

  // Función para obtener el LMS activo (D2L o Moodle)
  const getLmsActivo = async () => {
    if (!userSession?.profileObj?.email) {
      logger.debug('getLmsActivo: No hay email de usuario, saliendo');
      return;
    }

    const instance = Instancia(deployment);

    try {
      logger.debug('Llamando a GET /lmsActivo...');
      const response = await instance.get('lmsActivo');
      const { lms } = response.data;

      logger.debug('LMS Activo recibido:', lms);

      if (lms === 'moodle') {
        setUsesD2L(false);
      } else if (lms === 'd2l') {
        setUsesD2L(true);
      } else {
        // Si lms es null, mantener D2L por defecto
        setUsesD2L(true);
      }
    } catch (error) {
      logger.error('Error al obtener lmsActivo:', error);
      // En caso de error, mantener D2L por defecto
    }
  };

  // Función que gestiona un botón
  const handleOnclick = () => {
    if (variant === 'portal') {
      window.location.href = '/';
    } else {
      let empresa = 'cedesca';
      if (empresaId === 0 || empresaId === '0' || empresaId === 'CNTEC') {
        empresa = 'cntec';
      }

      window.location.href = `/alumnos/${empresa}/${studentStorage.id}/detalles`;
    }
  };

  // Función que gestiona el paginado
  const nextPage = (suma) => {
    let choosen = false;
    for (let i = 0; i < modulos.length; i++) {
      if (
        modulos[i].includes('Formación en centros de trabajo') ||
        modulos[i].includes('Formación en el centro de trabajo')
      ) {
        choosen = true;
      }
    }
    if (
      pageCont === 2 &&
      ((empresaId === 'CNTEC' && idDelegacionStudent.idCentro > 0) ||
        (empresaId === 'CEDESCA' && idDelegacionStudent.idCentro > 0))
    ) {
      setPageCont(4); // Saltamos la página del Descuento
    } else if (pageCont === 4 && choosen === false) {
      setPageCont(pageCont + 2);
    } else {
      setPageCont(pageCont + 1);
    }
    if (suma > 0) {
      setSumatorio(suma);
    }
  };

  // Función que gestiona el paginado
  const previousPage = () => {
    let choosen = false;
    for (let i = 0; i < modulos.length; i++) {
      if (
        modulos[i].includes('Formación en centros de trabajo') ||
        modulos[i].includes('Formación en el centro de trabajo')
      ) {
        choosen = true;
      }
    }

    if (pageCont === 6) {
      setSelectedOption('');
    }
    if (pageCont === 5 && choosen === false) {
      setPageCont(pageCont - 2);
    } else if (pageCont === 3) {
      setPageCont(pageCont - 1);
      setModulos([]);
    } else if (
      pageCont === 4 &&
      ((empresaId === 'CNTEC' && idDelegacionStudent.idCentro > 0) ||
        (empresaId === 'CEDESCA' && idDelegacionStudent.idCentro > 0))
    ) {
      setPageCont(2); // Saltamos la página del Descuento
    } else {
      setPageCont(pageCont - 1);
    }
  };

  return (
    <>
      {pageCont === 1 && (
        <ListadoEmpresas
          local={studentStorage}
          beginning={handleOnclick}
          next={nextPage}
          setEmpresaId={setEmpresaId}
        />
      )}
      {pageCont === 2 && (
        <ListadoGrupos
          local={studentStorage}
          userSession={userSession}
          beginning={handleOnclick}
          next={nextPage}
          previous={previousPage}
          id={id}
          empresaId={empresaId}
          setId={setId}
          setNombreGrupo={setNombreGrupo}
          setCodigoGrupo={setCodigoGrupo}
          variant={variant}
          deployment={deployment}
          mode={mode}
          idDelegacion={idDelegacion}
        />
      )}
      {pageCont === 3 && (
        <Descuento
          isFirstPeriod={isFirstPeriod}
          isSede={isSede}
          variant={variant}
          local={studentStorage}
          userSession={userSession}
          beginning={handleOnclick}
          next={nextPage}
          previous={previousPage}
          id={id}
          empresaId={empresaId}
          descuento={descuento}
          setDescuento={setDescuento}
          deployment={deployment}
          mode={mode}
        />
      )}
      {pageCont === 4 && (
        <ActividadesGrupos
          local={studentStorage}
          userSession={userSession}
          beginning={handleOnclick}
          next={nextPage}
          previous={previousPage}
          setModulos={setModulos}
          id={id}
          empresaId={empresaId}
          modulos={modulos}
          nombreGrupo={nombreGrupo}
          variant={variant}
          deployment={deployment}
          sumatorio={sumatorio}
          setSumatorio={setSumatorio}
          sumatorio2={sumatorio2}
          setSumatorio2={setSumatorio2}
          sumatorioSuelto={sumatorioSuelto}
          setSumatorioSuelto={setSumatorioSuelto}
          sumatorioSuelto2={sumatorioSuelto2}
          setSumatorioSuelto2={setSumatorioSuelto2}
          setActividades={setActividades}
          setIsSede={setIsSede}
          setPrecioFinal={setPrecioFinal}
          precioFinal={precioFinal}
          descuento={descuento}
          setPrecioCompleto={setPrecioCompleto}
          mode={mode}
        />
      )}
      {pageCont === 5 && (
        <ExcepcionFCT
          local={studentStorage}
          userSession={userSession}
          beginning={handleOnclick}
          next={nextPage}
          previous={previousPage}
          setModulos={setModulos}
          id={id}
          empresaId={empresaId}
          modulos={modulos}
          nombreGrupo={nombreGrupo}
          variant={variant}
          deployment={deployment}
          setExcepcion={setExcepcion}
          setSelectedOption={selectedOption}
        />
      )}

      {pageCont === 6 && (
        <TipoMatricula
          isFirstPeriod={isFirstPeriod}
          isSede={isSede}
          variant={variant}
          local={studentStorage}
          userSession={userSession}
          beginning={handleOnclick}
          next={nextPage}
          previous={previousPage}
          id={id}
          empresaId={empresaId}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          mode={mode}
        />
      )}

      {pageCont === 7 && (
        <PagoMatricula
          isFirstPeriod={isFirstPeriod}
          isSede={isSede}
          selectedOption={selectedOption}
          userSession={userSession}
          local={studentStorage}
          beginning={handleOnclick}
          previous={previousPage}
          id={id}
          next={nextPage}
          empresaId={empresaId}
          setPaymentMethod={setPaymentMethod}
          setPaymentType={setPaymentType}
          paymentMethod={paymentMethod}
          paymentType={paymentType}
          nombreGrupo={nombreGrupo}
          deployment={deployment}
          setIsPresencial={setIsPresencial}
          precioFinal={precioFinal}
          precioCompleto={precioCompleto}
          mode={mode}
          cuotaDates={cuotaDates}
          setCuotaDates={setCuotaDates}
        />
      )}

      {pageCont === 8 && (
        <Resumen
          local={studentStorage}
          userSession={userSession}
          beginning={handleOnclick}
          previous={previousPage}
          id={id}
          empresaId={empresaId}
          tipo={tipoCurso}
          modulos={modulos}
          nombreGrupo={nombreGrupo}
          nombreTipoCurso={nombreTipoCurso}
          variant={variant}
          deployment={deployment}
          mode={mode}
          idDelegacion={idDelegacion}
          excepcion={excepcion}
          precioFinal={precioFinal}
          actividades={actividades}
          codigoGrupo={codigoGrupo}
          paymentMethod={paymentMethod}
          paymentType={paymentType}
          selectedOption={selectedOption}
          isFirstPeriod={isFirstPeriod}
          isSede={isSede}
          descuento={descuento}
          isPresencial={isPresencial}
          usesD2L={usesD2L}
          cuotaDates={cuotaDates}
        />
      )}
    </>
  );
};

export default NuevaMatricula;
